import { useTranslation } from 'react-i18next';

import { SegmentedButton } from '@q-dev/q-ui-kit';
import { useWeb3Context } from 'context/Web3Provider';
import { ErrorHandler } from 'helpers';

import { networkConfigsMap } from 'constants/config';

function Network ({ className }: { className?: string}) {
  const { t } = useTranslation();

  const { chain, safeSwitchChain } = useWeb3Context();

  const isDevnet = ![
    networkConfigsMap.mainnet.daoAppUrl,
    networkConfigsMap.testnet.daoAppUrl,
  ].includes(window.location.origin);

  const networkOptions = [
    { value: 35441, label: t('MAINNET') },
    { value: 35443, label: t('TESTNET') },
    ...(isDevnet ? [{ value: 35442, label: t('DEVNET') }] : []),
  ];

  const handleChangeNetwork = async (chainId: number) => {
    try {
      await safeSwitchChain(chainId);
    } catch (error) {
      ErrorHandler.process(error, (error as { details?: string })?.details || t('SWITCH_NETWORK_ERROR'));
    }
  };

  return (
    <SegmentedButton
      className={className}
      value={chain.id}
      options={networkOptions}
      onChange={handleChangeNetwork}
    />
  );
}

export default Network;
